import { CalendarDays } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const toIso = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
const fromIso = (value: string) => new Date(`${value}T12:00:00`);

/** Calendário de várias datas soltas, em popover. */
export function MultiDateField({ value, onChange }: { value: string[]; onChange: (dates: string[]) => void }) {
  const { t } = useTranslation("daycareHotel");
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="flex h-10 w-full items-center gap-2 rounded-lg border border-border bg-background px-3 text-left text-sm text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring sm:w-auto"
        >
          <CalendarDays aria-hidden="true" size={15} className="text-muted-foreground" />
          {t("reservationDates.pickLabel")}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-2" align="start">
        <Calendar
          mode="multiple"
          selected={value.map(fromIso)}
          onSelect={(dates) => onChange([...new Set((dates ?? []).map(toIso))].sort())}
        />
      </PopoverContent>
    </Popover>
  );
}
